// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: "AIzaSyBwKXaJxtfmh_CDxva5NQz5OuaNCHe6ltY",
  authDomain: "superserver-79983.firebaseapp.com",
  databaseURL: "https://superserver-79983.firebaseio.com",
  projectId: "superserver-79983",
  storageBucket: "superserver-79983.appspot.com",
  messagingSenderId: "664719775668",
  appId: "1:664719775668:web:5869131d6ca4581a7684e1"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
